import { render, staticRenderFns } from "./ListItemsCreateEditModal.vue?vue&type=template&id=547483a2&"
import script from "./ListItemsCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./ListItemsCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ListItemsCreateEditModal.vue?vue&type=style&index=0&id=547483a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports